import styled from 'styled-components';

export const ConfigFooterCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const ConfigValueDescription = styled.div`
  color: #666;
  font-size: 0.9em;
  margin-bottom: 10px;
`

export const LastUpdate = styled.div`
  color: #999;
  font-size: 0.75em;
  margin-bottom: 5px;
`